import * as React from "react";
import { AgGridReact } from "ag-grid-react";
import { useState, useEffect } from "react";
import { DownloadDocument, GetCSDocumentsAPI } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { SBNotify } from "../utils/sbNotify";
import moment from "moment";
import { WidgetCollectionContext } from "./home";
import CloseSVG from "../../Images/close_svg.svg"
import { useContext } from "react";


const todayDate = new Date();
const previousMonthEndDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0);


const ActionColumnCellRenderer = (params) => {

  const reportdownload = (DocId) => {
    if (DocId == 0) {
      SBNotify({ Msg: "Document Not Mapped.", type: "error" });
    }
    else {
      downloadDocument(DocId);
    }
  }
  const downloadDocument = (documentId) => {
    const urlBuild = DownloadDocument + btoa(documentId.toString());
    sbaAxios({ url: urlBuild }).then(response => {
      window.open(urlBuild);
    })
  };

  const isApprovedOrPublished = params.data.CSStatus === "Approved" || params.data.CSStatus === "Published";
  return <>
    <div className="pdf-icon-wrapper">
      <i
        className="far fa-file-pdf text-danger SBA_hand"
        onClick={() => {
          reportdownload(params.data.DocumentID);
        }}
      />
      {isApprovedOrPublished && (
        <i className="fas fa-check-circle overlay-icon text-success" />
      )}
    </div>
  </>
}
const ClientStatement = ({ }) => {
  const { removeWidget , toCustomize } = useContext(WidgetCollectionContext);
  const [gridData, setgridData] = useState([]);
  useEffect(() => {
    geDashboardCSDocuments();
  }, []);


  const geDashboardCSDocuments = async () => {
    try {
      const response = await sbaAxios({ url: `${GetCSDocumentsAPI}` });
      setgridData(response);

      // refreshTitles();
    }
    catch (error) {
      console.error(error);
    }
  }
  const colDef = [
    { headerName: "Family Name", field: "FamilyName" },
    { headerName: "Client Statement", field: "ClientStatementName" },
    { headerName: "Document Name", field: "DocumentName" },
    { headerName: "", field: "", maxWidth: 100, cellRenderer: ActionColumnCellRenderer },
  ]
  const defColDef = { flex: 1,resizable:true };
  return <>
  <div className="k-tilelayout-item k-card k-cursor-grab h-100">
    <div className="k-tilelayout-item-header k-card-header">
      <div className="header-container">
        <b> Client Statement
        as of {moment(previousMonthEndDate).format('MM/DD/yyyy')}
      </b>
      {toCustomize && <a className="ms-auto" href="#" onClick={() => {
          removeWidget(2)
        }}>
          <img src={CloseSVG}
            alt="close" />
    </a>}
    </div>
    </div>
    <div className="k-tilelayout-item-body k-card-body">
    <div className="ag-theme-alpine">
      <AgGridReact
        rowData={gridData}
        columnDefs={colDef}
        defaultColDef={defColDef}

      ></AgGridReact>
    </div>
    </div>
    </div>
  </>
};
export default ClientStatement;